module.exports = __webpack_public_path__ + "static/img/teacher.19326aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teacher.png
// module id = I0jz
// module chunks = 269